import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import * as R from 'ramda';
import { JsonToTable } from 'react-json-to-table';
import { getLeadInformation  } from '../util/api';
import LoadingModal from '../components/dumb/LoadingModal';

function LeadInfoPage() {
  const { leadId } = useParams();
  const [ loading, setLoading ] = useState(false);
  const [ data, setData ] = useState(undefined);

  useEffect(() => {
    document.title = 'View Lead Information';
  }, [])

  useEffect(() => {
    setLoading(true);
    getLeadInformation(leadId)
      .then(data => {
        console.log(`data = ${JSON.stringify(data)}`)
        setData(data);
        setLoading(false);
      });
  }, [leadId]);

  return (
    <div>
      <h3> Lead Information </h3>
      <h4> Basic Information </h4>
      {
        !R.isNil(data) &&
        (
          <>
            <center> <h5> Name: { data.lead.name } </h5> </center>
            <center> <h5> Batch: { data.lead.targetBatch } </h5> </center>
            <center> <h5> Last Updated Date: { data.lead.lastUpdatedDate } </h5> </center>
            <center> <h5> Current Profession: { data.lead.currentProfession } </h5> </center>
            <center> <h5> Current Experience: { data.lead.currentExperience } </h5> </center>
            <center> <h5> Current Industry: { data.lead.currentIndustry } </h5> </center>
            <JsonToTable json={data} />
          </>
        )
      }
      {
        loading === true && <LoadingModal />
      }
    </div>
  )
}


export default LeadInfoPage;
